export const BACKGROUND_COLOR = '#F0F8FF';
export const BUTTON_BOX_SHADOW_STYLE =
  '0px 2px 4px -1px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.03)';
